import { useState } from 'react';
import { useModal } from '../contexts';
import TextInputField from './TextInputField';
import ColorPickerField from './ColorPickerField';
import Modal from './Modal';
import { WorkflowFolder } from '../interfaces';

interface Props {
  updateFolder: ((folder: WorkflowFolder) => void);
  folder?: WorkflowFolder;
  acceptText?: string;
  titleText?: string;
}

function FolderModal(props: Props) {
  const [folder, setFolder] = useState<WorkflowFolder>(props.folder ?? { name: 'New Folder', color: '#cccccc' } as WorkflowFolder);
  const { closeModal } = useModal();

  return (
    <Modal
      title={props.titleText ?? "Update Folder"}
      primaryButtonProps={{
        text: props.acceptText ?? 'Update',
        onClick: () => { props.updateFolder(folder); }
      }}
      secondaryButtonProps={{ text: "Cancel", onClick: closeModal }}
    >
      <TextInputField label="Workflow Name" value={folder.name} onChange={(name) => setFolder((w: any) => ({ ...w, name }))} required />
      <div className="mt-4 text-gray-600 font-gilroy font-semibold">
        Appearance
      </div>
      <div className="flex gap-16">
        <ColorPickerField value={folder.color} onChange={(color) => setFolder((w: any) => ({ ...folder, color }))} />
      </div>
    </Modal>
  );
}

export default FolderModal;
